import { StringType } from "./strings";

const STRING_EN: StringType = {
  translation: {
    general: {
      loading: "Loading...",
    },
    burgerMenu: {
      dutyPlan: "Duty plan",
      dashboard: "Dashboard",
      lights: "Lights",
      jokeOfTheDay: "Joke of the day",
      settings: "Settings",
      deliveryDriver: "Delivery drivers",
      wifi: "WiFi",
      camera: "Camera",
      images: "Images",
      scavengerhunt: "Scavenger hunt",
    },
    dutyCard: {
      tasks: "Tasks",
      tasksInDetail: "Tasks in detail",
      everyWeek: "every week",
      everyXWeeks_one: "every {{count}} week",
      everyXWeeks_other: "every {{count}} weeks",
      day_one: "{{count}} Day",
      day_other: "{{count}} Days",
    },
    trashCalendar: {
      title: "Trash calendar",
    },
    duties: {
      bathroom: {
        name: "Bathroom",
        quote:
          "He, who finds himself upon the edge of rectal release, may enjoy this very moment!",
        generalTasks: {
          bathroom: "Bathroom",
          trash: "Trash",
        },
        detailedTasks: {
          cleanToilet: "Clean toilet",
          cleanSink: "Clean sink",
          cleanShower: "Clean shower",
          cleanFurniture: "Clean furniture",
          disposeTrash: "Dispose trash",
          disposeCompost: "Dispose compost",
        },
      },
      floor: {
        name: "Floor",
        quote: "The floor is below us!",
        generalTasks: {
          livingRoom: "Livingroom",
          floor: "Floor",
          glasAndCans: "Glas & Cans",
        },
        detailedTasks: {
          cleanSofa: "Clean sofa",
          lamps: "lamps",
          vacuumClean: "Vacuum clean",
          wipeFloor: "Wipe the floor",
          disposeGlasAndCans: "dispose glas & cans",
          waterPlants: "Water plants",
        },
      },
      kitchen: {
        name: "Kitchen",
        quote:
          "Even the greatest of them all can't wipe his feet without an El Tony!",
        generalTasks: {
          kitchen: "Kitchen",
          petAndPlasticBottles: "PET- and plastic bottles",
          cardboardAndPaper: "Cardboard and paper",
        },
        detailedTasks: {
          cleanStoveTableAndSink: "Clean stove, table and sink",
          cleanSurfaces: "Clean surfaces",
          cleanTrashCabinet: "Clean trash cabinet",
          cleanSteamExhaust: "Clean steam exhaust",
          disposeCardboardAndPaper: "Dispose cardboard and paper",
          disposePetAndPlasticBottles: "Dispose PET- and plastic bottles",
        },
      },
    },
    weatherCodes: {
      sunny: "Sunny",
      clear: "Clear",
      mainlySunny: "Mainly Sunny",
      mainlyClear: "Mainly Clear",
      partlyCloudy: "Partly Cloudy",
      cloudy: "Cloudy",
      foggy: "Foggy",
      rimeFog: "Rime Fog",
      lightDrizzle: "Light Drizzle",
      drizzle: "Drizzle",
      heavyDrizzle: "Heavy Drizzle",
      lightFreezingDrizzle: "Light Freezing Drizzle",
      freezingDrizzle: "Freezing Drizzle",
      lightRain: "Light Rain",
      rain: "Rain",
      heavyRain: "Heavy Rain",
      lightFreezingRain: "Light Freezing Rain",
      freezingRain: "Freezing Rain",
      lightSnow: "Light Snow",
      snow: "Snow",
      heavySnow: "Heavy Snow",
      snowGrains: "Snow Grains",
      lightShowers: "Light Showers",
      showers: "Showers",
      heavyShowers: "Heavy Showers",
      lightSnowShowers: "Light Snow Showers",
      snowShowers: "Snow Showers",
      thunderstorm: "Thunderstorm",
      lightThunderstormsWithHail: "Light Thunderstorm With Hail",
      thunderstormWithHail: "Thunderstorm With Hail",
    },
    deliveryDrivers: {
      orderedOn: "Ordered On",
      order: "Order:",
    },
    camera: {
      done: "Done!",
      imagePreviewInfoText: "This image can be viewed on the Images page",
    },
    settings: {
      language: "Language",
      theme: "Theme",
      reload: "Reload Website",
    },
  },
};

export default STRING_EN;
